module.exports = __webpack_public_path__ + "img/account.8bb7d81b.svg";